import { ROUTES } from "../Routes/routes";
import GenericLayout from "./GenericLayout";

export default function CentralManagerHubLayout() {
  const menu = [
    {
      key: ROUTES.CENTRAL.Manager.MANAGER_DashboardManagerCentralHub,
      label: "Dashboard",
      icon: "bi bi-speedometer",
      iconImage: ""
    },
    {
      key: ROUTES.CENTRAL.Manager.MANAGER_CancelOrder,
       label: "Cancelled Orders",
      icon: "bi-x-octagon-fill",
      iconImage: ""
    },
       {
      key: ROUTES.CENTRAL.Manager.CompleteOrder,
      label: "Complete Order",
      icon: "bi-patch-check-fill",
      iconImage: ""
    },
//     {
//   key: ROUTES.CENTRAL.Manager.MANAGER_ManagerScheduledOrders,
//   label: "ScheduleOrders",
//   icon: "bi-patch-check-fill",
//       iconImage: ""
// },
    {
      key: ROUTES.CENTRAL.Manager.ManagerContactSupport,
      label: "Contact Support",
      icon: "bi-headset",
      iconImage: ''
    },
//     {
//   key: ROUTES.CENTRAL.Manager.RealtimeOrderTracking,
//       label: "Realtime Order Tracking",
// icon: "bi-truck",
//         iconImage: ''
// },

    {
      key: ROUTES.CENTRAL.Manager.ManagerSLABreachMonitor,
      label: "SLA Breach Monitor",
      icon: "bi-exclamation-triangle-fill",
      iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Manager.MANAGER_DeliveryPartner,
      label: "Delivery Partner",
      icon: "bi-truck-front-fill",
      iconImage: ""
    },

 

    {
      key: ROUTES.CENTRAL.Manager.MANAGER_ManagerReport,
      label: "Report",
      icon: "bi-file-earmark-text-fill",
      iconImage: ""
    },

    {
      key: ROUTES.CENTRAL.Manager.MANAGER_ManagerDesignerPerformance,
      label: "Designer Performance",
      icon: "bi-palette-fill",
      iconImage: ""
    },
    {
      key: ROUTES.CENTRAL.Manager.MANAGER_ManagerMillingResourceOverview,
      label: "Milling Resource Overview",
      icon: "bi-cpu-fill",
      iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Manager.MANAGER_ManagerDispatchOverview,
      label: "Dispatch Overview",
      icon: "bi-box-seam-fill",
      iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Manager.MANAGER_ManagerMillingPerformance,
      label: "Milling Performance",
      icon: "bi-bar-chart-line-fill",
      iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Manager.ManagerRejectedOrder,
      label: "Reject Orders",
      icon: "bi-slash-circle-fill",
      iconImage: ''
    },
     {
      key: ROUTES.CENTRAL.Manager.ManagerWarrantyClaimResponse,
      label: "Reply Warranty Claim",
      icon: "bi-star-fill",
      iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Manager.ManagerTicket,
      label: "Reply Raise Ticket",
      icon: "bi-tags-fill",
      iconImage: ''
    }

  ];

  return (
    <GenericLayout
      menu={menu}
      titleLabel="Central Hub"
      profileRoute={ROUTES.CENTRAL.CENTRAL_PROFILE}
      showNotifications
      apiNotificationUrl={`${process.env.REACT_APP_API_BASE_URL}/ClinicDetails/GetClinicNotifications`}
    />
  );
}
